var HeroImagesSlideShow=function(){var e,o,a,n,r;$(".parallax").length&&!Modernizr.touch&&skrollr.init(),e=$(".shopify-section--header"),a=0,o=0,n=function(e){return $(".slideshow-nav li.active").removeClass("active"),e?(console.log(e+" "+a),a!==e&&$(".hero-images .hero-image:eq("+a+")").fadeOut(),$(".hero-images .hero-image:eq("+e+")").fadeIn(),a=e):a<$(".hero-images .hero-image").length-1?($(".hero-images .hero-image:eq("+a+")").fadeOut(),a+=1):($(".hero-images .hero-image:eq("+a+")").fadeIn(),a=0),$(".slideshow-nav li:eq("+a+")").addClass("active"),$(".hero-images .hero-image:eq("+a+")").fadeIn().data("header-transparency")?$("#main-header").addClass("transparent").data("has-transparency",!0):$("#main-header").removeClass("transparent").data("has-transparency",!1)},r=function(){return o=setInterval((function(){return n()}),6e3)},$(".hero-images").length&&$(".hero-images .hero-image").length>1&&(r(),$(".slideshow-nav li a").on("click",(function(e){var a;return e.preventDefault(),a=parseInt($(this).parent().data("slideshow-index")),console.log(a),$(".hero-images .hero-image").fadeOut(),$(".hero-images .hero-image.slide-"+a).fadeIn(),console.log(o),clearInterval(o)})),$(".hero-image .border-button").mouseenter((function(){return clearInterval(o)})),$(".hero-image .border-button").mouseleave((function(){return clearInterval(o)}))),$("body").waypoint((function(a){if("down"!==a)return $("#main-content").removeClass("undocked"),e.removeClass("small"),$(".header-subnav.visible").removeClass("visible"),e.data("has-transparency")&&e.addClass("transparent"),r();$("#main-content").addClass("undocked"),clearInterval(o),e.addClass("small"),e.data("has-transparency")&&e.removeClass("transparent")}),{offset:-10}),console.log($(".index-parallax-slider + .index-sections").length),$(".index-parallax-slider + .index-sections").length&&$(".index-sections").addClass("has-hero-image-top")},SaleOnClassAddRemove=function(){0!=$(".mega-menu-6 .dropdown_content").children().length?$('.mega-menu-parent[data-dropdown-rel="sale"]').addClass("sale-on"):$('.mega-menu-parent[data-dropdown-rel="sale"]').removeClass("sale-on")},VerticalSliderThumbnails=function(){$(".custom-product-thumnails-gallery").slick({dots:!1,infinite:!1,vertical:!0,verticalSwiping:!0,speed:300,slidesToShow:5,slidesToScroll:5,arrows:!0,prevArrow:'<button type=\'button\' class=\'slick-prev pull-left\'><svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C12.2652 3 12.5196 3.10536 12.7071 3.29289L19.7071 10.2929C20.0976 10.6834 20.0976 11.3166 19.7071 11.7071C19.3166 12.0976 18.6834 12.0976 18.2929 11.7071L13 6.41421V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V6.41421L5.70711 11.7071C5.31658 12.0976 4.68342 12.0976 4.29289 11.7071C3.90237 11.3166 3.90237 10.6834 4.29289 10.2929L11.2929 3.29289C11.4804 3.10536 11.7348 3 12 3Z" fill="#000000"></path> </g></svg></button>',nextArrow:'<button type=\'button\' class=\'slick-next pull-right\'><svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C12.2652 3 12.5196 3.10536 12.7071 3.29289L19.7071 10.2929C20.0976 10.6834 20.0976 11.3166 19.7071 11.7071C19.3166 12.0976 18.6834 12.0976 18.2929 11.7071L13 6.41421V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V6.41421L5.70711 11.7071C5.31658 12.0976 4.68342 12.0976 4.29289 11.7071C3.90237 11.3166 3.90237 10.6834 4.29289 10.2929L11.2929 3.29289C11.4804 3.10536 11.7348 3 12 3Z" fill="#000000"></path> </g></svg></button>',responsive:[{breakpoint:1024,settings:{slidesToShow:4,slidesToScroll:4,infinite:!0,dots:!0}},{breakpoint:799,settings:"unslick"}]})},ReadMoreProdDescription=function(){$(".custom-product-bottom-description").readmore({speed:75,lessLink:'<a class="read_less" href="#">Read less</a>'}),$(document).on("click",".read_less",(function(){$("html, body").animate({scrollTop:$(".custom-product-bottom-description").offset().top-150},{duration:1e3})}))},CollectionShopSlider=function(){$(".collection-mobile-slider").flickity({cellAlign:"left",contain:!0})},HomePagePopUP=function(){Cookies.get("popup")?$(".popup_image").find(".popup-overlay").hide():setTimeout((function(){$(".popup_image").find(".popup-overlay").fadeIn("slow")}),5e3),$(document).on("click",".popup-overlay",(function(){Cookies.get("popup")?$(this).hide():$(this).fadeOut("slow")})),$(".pop-close").click((function(){Cookies.set("popup","popupId",{expires:7}),$(".popup-overlay").fadeOut("slow")})),$(document).on("click",".popup-body",(function(e){e.stopPropagation()}))};HeroImagesSlideShow(),SaleOnClassAddRemove(),VerticalSliderThumbnails(),ReadMoreProdDescription(),CollectionShopSlider(),HomePagePopUP(),$(document).on("shopify:section:load",(function(e){HeroImagesSlideShow(),SaleOnClassAddRemove(),VerticalSliderThumbnails(),ReadMoreProdDescription(),CollectionShopSlider(),HomePagePopUP()}));

$(window).on('load', function() {  
$('.bold_option_title:contains("ImageSwap-")').each(function() {
var elementTitle = $(this).html().replace("ImageSwap-", "");
var selectTitle = $(this).siblings('.bold_option_element').children('select').children('option').first().text().replace("ImageSwap-", "");

// Update title and add classes
$(this).html(elementTitle);
$(this).siblings('.bold_option_element').children('select')
.addClass('image-swap')
.children('option').first().text(selectTitle);

$(this).siblings('.bold_option_element').find('input[type="radio"]').addClass('image-swatch');
});
});

$(document).on('click','.hero-image section .border-button.sale-btn-trigger', function(event) 
{
event.preventDefault();
if($( window ).width() > 768) 
{
$('.nav-desktop__tier-1 li.nav-desktop__tier-1-item:nth-last-child(2), .custom-mobile-dropdown-menu').trigger('click');
} 
else 
{
$('.mobile_nav').trigger('click');
if(!$('#mobile_menu div.mobile-menu-item-title.sale-menu-item').parent().hasClass('active')) 
{
$('#mobile_menu div.mobile-menu-item-title.sale-menu-item').parent().trigger('click');
}
}
});

// ToolTip Swatch Js //

$(document).ready(function () {
    const $tooltip = $('<div class="tooltip"></div>').appendTo('body').hide();
    $("<style>").text(`
        .tooltip {
            position: absolute;
            background: #fff;
            border: 1px solid #ccc;
            padding: 5px;
            border-radius: 5px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
            z-index: 9;
            max-width: 150px; 
            word-wrap: break-word;
        }
    `).appendTo("head");

    const margin = 10; 

    setInterval(() => {
        $(".bold_option_radio .swatch-image img:not([data-tooltip-initialized])").each(function () {
            const $img = $(this).data("tooltip-initialized", true);
            $img.on("mouseover", function () {
                const imgSrc = $img.attr("data-tooltip-img");
                if (imgSrc) $tooltip.html(`<img src="${imgSrc}" style="max-width:100%;max-height:100px;">`).show();
            }).on("mousemove", (e) => {
                const tooltipWidth = $tooltip.outerWidth();
                const viewportWidth = $(window).width();
                let leftPosition = e.pageX - tooltipWidth / 2;
                const topPosition = e.pageY + 15;

                if (leftPosition < margin) leftPosition = margin; 
                if (leftPosition + tooltipWidth > viewportWidth - margin) {
                    leftPosition = viewportWidth - tooltipWidth - margin; 
                }

                $tooltip.css({ left: leftPosition, top: topPosition });
            }).on("mouseout", () => $tooltip.hide());
        });
    }, 1000);
});

// End ToolTip Swatch Js //


// Image swap remove from cart title code start 

$(document).ready(function(){
  $('.cart__item--title a').each(function () {
    var text = $(this).text();
    if (text.startsWith('ImageSwap-')) {
      var newText = text.replace('ImageSwap-', '');
      $(this).text(newText);
    }
  });
});

// Image swap remove from cart title code end


// shipping calculator show/hide and top margin from header js code start

$(document).ready(function() {
  function adjustMarginTop() {
    var maxHeaderHeight = 0;
    $('.custom-header-height').each(function () {
      var currentHeight = $(this).outerHeight();
      console.log('Current Header Height:', currentHeight);
      if (currentHeight > maxHeaderHeight) {
        maxHeaderHeight = currentHeight;
      }
    });
    $('.cstm_cart_wrapper_new').css('margin-top', maxHeaderHeight);
  }
  function toggleShippingCalculator() {
    if ($(window).width() <= 798) {
      $('#shipping-calculator h4').off('click').on('click', function() { 
        $(this).toggleClass('active');
        $('#shipping-calculator-form-wrapper').stop(true, true).slideToggle();
      });
    } else {
      $('#shipping-calculator-form-wrapper').stop(true, true).show();
    }
  }
  adjustMarginTop();
  toggleShippingCalculator();
  $(window).resize(function() {
    adjustMarginTop();
    toggleShippingCalculator();
  });
});

// shipping calculator show/hide and top margin from header js code end
